import React, { FunctionComponent } from 'react';
import InvestmentPages from './pages';

const InvestmentApp: FunctionComponent = () => {
  return <InvestmentPages />;
};

export default InvestmentApp;
